import { Component } from '@angular/core';

@Component({
  selector: 'app-cards9-examples-61',
  templateUrl: './cards9-examples-61.component.html'
})
export class Cards9Examples61Component {}
